// FLAGS: none
// The public event page's shareable links, one per language the event can be read in.
import Spinner from "@openup/shared/components/Spinner/Spinner";

import LocalizedLinkList from "@src/components/spaces/LocalizedLinkList";
import { useEvent } from "@src/queries/events";

/**
 * Unlike the other two tabs, there is nothing to mint here: the public page
 * exists as soon as the event does, and its URL is derived from the event id.
 * The links come from the API because the language lives in each URL's domain
 * and only the server knows which domain serves which language.
 */
const PublicPageLinks = ({ eventId }: { eventId: string }) => {
  const { data: event, isLoading, isError } = useEvent(eventId);

  if (isLoading) {
    return (
      <div className="flex justify-center py-6">
        <Spinner />
      </div>
    );
  }

  if (isError || !event) {
    return (
      <p className="text-sm text-red-600">
        Couldn&apos;t load the public page links. Please try again.
      </p>
    );
  }

  if (event.publicPageUrls.length === 0) {
    return (
      <p className="text-sm text-gray-600">
        Set the event language before sharing the public page, so the link opens
        in the language its content is written in.
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <LocalizedLinkList
        links={event.publicPageUrls}
        singleLabel="Public landing page"
      />
      <p className="text-sm text-gray-600">
        Anyone with this link can read the session and sign up. No invitation is
        needed, and registration still requires a company that this space is
        for.
      </p>
    </div>
  );
};

export default PublicPageLinks;
